import { defineStore } from "pinia";
import Services from '@/services/sutting/institutionsServices'
import { mapList, mapInstitution } from '@/helpers/mapFuncs'

export const useInstitutionsStore = defineStore("institutions", {
persist: true,
state:()=>({
    institution: {},
    institutions: [],
}),
getters : {
    getInstitution() {
        return mapInstitution(this.institution)
    },
    getInstitutions() {
        return this.institutions.map(mapInstitution)
    },
    getInstitutionsList() {
        return this.institutions.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setInstitution(institution) {
        this.institution = institution
    },
    setInstitutions(institutions) {
        this.institutions = institutions
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setInstitution(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setInstitutions(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.institutions.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.institutions[this.institutions.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.institutions = this.institutions.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
